<div
  class="flex justify-between items-center rounded-2xl expansion-panel-header"
  [class]="isParentToggled() ? '!rounded-t-2xl rounded-b-none' : ''"
  (keypress)="this.keypressHandler($event)"
  tabindex="0"
>
  <ng-content></ng-content>
  <div class="flex items-center gap-4 pl-4 pr-4">
    <button mat-icon-button aria-label="pin button" class="header-icon-button" (click)="onPinToggle()">
      <lib-app-icon
        className="pin-color"
        matListItemIcon
        [icon]="isPinned ? 'pinned_icon' : 'hollow_pin_icon'"
        [size]="'24x24'"
      />
    </button>
    <button
      mat-icon-button
      aria-label="toggle expnasion button"
      [ngClass]="getToggleButtonClass()"
      (click)="toggleParent()"
    >
      <lib-app-icon matListItemIcon icon="downward_arrow_icon" [size]="'24x24'" />
    </button>
  </div>
</div>
